import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';

import {name , description} from '../../validations/validation';

// styles , icons and images
import { Container, Row, Col } from 'react-bootstrap';
import { TextField, InputLabel, Button, Chip, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import './overview.style.css';

// this component represents the create and edit  visume page

class Overview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            // privacy: 1,
            // public: 1,
            // private: 2,
            brief: "",
            speciality: "",
            tags: [],
            specialities: [],
            tagsChoosen: [],
            // checkPublic : true,
            // checkPrivate : false 
        }
    }
    componentWillReceiveProps(props) {
        //handle props that receive on the edit 
        if (props.data) {
            let data = props.data;
            // console.log(data.privacy.id);
            // let checkPublic = data.privacy.id === 1 ? true : false;
            // let checkPrivate =  data.privacy.id === 2 ? true : false;

            // console.log(checkPublic , checkPrivate);
            console.log(data.speciality)
            this.setState({
                ...this.state, bioId: data.id,
                title: data.title, brief: data.brif,
                speciality: data.speciality.name_en,
                specialityId: data.speciality.id,
                tagsChoosen: data.bioTagsNames, 
                // privacy: data.privacy.id ,
                // checkPrivate : checkPrivate ,
                // checkPublic : checkPublic
            });
        }

    }
    componentDidMount(props) {

        //handle fetch specialities and tags dropdown   
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = 'https://spreago.black-squares.com/graphql';
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;

            next();
        });
        //get specialites
        apolloFetch({
            query:
                `query{
            specialities{
              id
              context
              name
              name_en
              name_ar
              created_at
              updated_at
             
            }
          }
        `,
        }).then(res => {
            if (res.data.specialities) {
                this.setState({ ...this.state, specialities: res.data.specialities });
            }
        });
        //get tags
        apolloFetch({
            query:
                `query{
                tag{
                  id
                  name
                 
                }
              }
            `,
        }).then(res => {
            if (res.data.tag) {
                this.setState({ ...this.state, tags: res.data.tag });
            }
        });
        //get privecy
        // apolloFetch({
        //     query:
        //         ` query{
        //         privacies{
        //         id
        //         context
        //         name
        //         name_en
        //         name_ar
        //         created_at
        //         updated_at
               
        //         }
        //     }
        //     `,
        // }).then(res => {

        //     if (res.data.privacies) {
        //         this.setState({ ...this.state, public: res.data.privacies[0], private: res.data.privacies[1] });
        //     }
        // });
    }
    render() {
        const handleChange = props => event => {
            console.log(props , event.target.value)
            this.setState({ ...this.state, [props]: event.target.value , errorMessage : '' , briefErrorMessage : '' , specialityErrorMessage: '' ,ConnectionErorr : '' });
        };
        // input validation
        const checkTitle = (title) => {
            if (name(title)) {
                let error = name(title);
                this.setState({ ...this.state, errorMessage: error });
                return false;

            } else {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
        }
        const checkBrief = (brief) => {
            if (brief == null) {
                this.setState({ ...this.state, briefErrorMessage: '' });
                return true;
            }
            else if (brief.length > 5000) {
                this.setState({ ...this.state, briefErrorMessage: 'This field must be max  5000 characters long.' });
                return false;

            }
            else {
                this.setState({ ...this.state, briefErrorMessage: '' });
                return true;
            }
        }
        const checkSpeciality = () => {
            if (!this.state.specialityId) {
                this.setState({ ...this.state, specialityErrorMessage: 'You must choose one from the list.' });
                return false;
            }
            else {
                this.setState({ ...this.state, specialityErrorMessage: '' });
                return true;
            }
        }
        // if specialites or tags dropdown not loaded from server return loading message 
        // if (this.state.specialities.length < 1 && this.state.tags.length < 1 && this.state.public.length < 1 && this.state.private.length < 1) {

        if (this.state.specialities.length < 1 && this.state.tags.length < 1 ) {
            return (
                <div><h5 className="text-dark">Loading....</h5></div>
            )
        } else {
            return (
                <div className="pb-3 overview-tap">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            if (checkTitle(this.state.title) && checkSpeciality() && checkBrief(this.state.brief)) {

                                this.setState({ ...this.state, errorMessage: '' });
                                // send data to server on submit 
                                // if there is bio/visume id , edit to this bio/visume id
                                // if not create new one
                                if (this.state.bioId) {
                                    this.props.edit_bio({
                                        variables: {
                                            bio_id: this.state.bioId,
                                            specialities_id: this.state.specialityId,
                                            title: this.state.title,
                                            brif: this.state.brief,
                                            tags: this.state.tagsChoosen
                                        }
                                    }).then((res) => {
                                        if (res.data.bioEdit.Status.code === 200) {
                                            // go to next form  
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            let list = document.getElementById("left-tabs-example");
                                            let nav_items = list.querySelectorAll(".nav-item a");
                                            nav_items[0].setAttribute("data-id", this.state.bioId);
                                            nav_items[1].click();
                                        }
                                    }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                } else {
                                    this.props.create_bio({
                                        variables: {
                                            specialities_id: this.state.specialityId,
                                            title: this.state.title,
                                            brif: this.state.brief,
                                            tags: this.state.tagsChoosen
                                        }
                                    }).then((res) => {
                                        if (res.data.bioCreate.Status.code === 200) {
                                            this.setState({ ...this.state, bioId: res.data.bioCreate.bio.id });
                                            // go to next form  
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            let list = document.getElementById("left-tabs-example");
                                            let nav_items = list.querySelectorAll(".nav-item a");
                                            nav_items[0].setAttribute("data-id", res.data.bioCreate.bio.id);
                                            nav_items[1].click();
                                            // make this tab disabled  
                                            nav_items[0].setAttribute("aria-disabled", "true");
                                            nav_items[0].classList.add("disabled");
                                        }
                                    }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                }
                            }
                        }} >
                        <Container className="overview shadow border-rounded">
                            <Row>
                                <Col className="border-bottom bg-light p-5" sm={12}>
                                    <div className="title">
                                        <h4 className="text-dark">Overview</h4>
                                        <p className="text-grey mb-0">Provide the employer with your main information</p>
                                    </div>
                                </Col>
                                <Col sm={12} className="bg-white p-5">
                                    <InputLabel htmlFor="title">
                                        Title<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        value={this.state.title}
                                        onChange={handleChange('title')}
                                        className="pt-1 pb-1"
                                        placeholder="Write your title"
                                        fullWidth
                                        variant="outlined"
                                    />
                                    <Col xs={12} className="p-0  pb-4">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                                    </Col>
                                    <InputLabel htmlFor="brief">
                                        Brief
                                    </InputLabel>
                                    <TextField
                                        name="brief"
                                        id="brief"
                                        value={this.state.brief || ''}
                                        onChange={handleChange('brief')}
                                        className="pt-1 pb-1"
                                        multiline
                                        rows="7"
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Write your Brief"
                                        helperText="0 / 5000 Characters"
                                    />
                                    <Col xs={12} className="p-0 pb-4">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.briefErrorMessage}</Typography>
                                    </Col>
                                    <InputLabel htmlFor="speciality">
                                        Speciality<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <Autocomplete
                                        name='speciality'
                                        value={this.state.speciality}
                                        onChange={(event, value) => {
                                            this.setState({ ...this.state, speciality: value });
                                            let specialitychoosen = [];
                                            specialitychoosen = this.state.specialities.filter((speciality) => {
                                                return speciality.name === value
                                            });
                                            if (specialitychoosen.length > 0) {
                                                this.setState({ ...this.state, specialityErrorMessage: "", specialityId: specialitychoosen[0].id })
                                            }
                                            else {
                                                this.setState({ ...this.state, specialityId: '' })
                                            }
                                        }}
                                        id="free-solo-demo"
                                        className="pt-1 pb-1"
                                        freeSolo
                                        options={this.state.specialities.map(option => option.name)}
                                        renderInput={params => (
                                            <TextField {...params} variant="outlined" placeholder="choose speciality" />
                                        )}
                                    />
                                    <Col xs={12} className="p-0 pb-4">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.specialityErrorMessage}</Typography>
                                    </Col>
                                    <InputLabel htmlFor="tags">
                                        Related tags
                                    </InputLabel>
                                    <Autocomplete
                                        multiple
                                        id="tags"
                                        className="pt-1 mb-4"
                                        value={this.state.tagsChoosen}
                                        onChange={
                                            (event, value) => this.setState({ ...this.state, tagsChoosen: value })
                                        }
                                        options={this.state.tags.map(option => option.name)}
                                        freeSolo
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                            ))
                                        }
                                        renderInput={params => (
                                            <TextField {...params} variant="outlined" placeholder="" />
                                        )}
                                    />
                                    {/* <InputLabel htmlFor="privacy">
                                        Privacy<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <div className="pt-1 pb-4">
                                        <div className="input-radio">
                                            <input type="radio" id="public" name="privacy"  defaultChecked={this.state.checkPublic && this.state.checkPublic}  onChange={handleChange('privacy')}  value={this.state.public.id}  />
                                            <label htmlFor="public" className="first-btn">Public</label>
                                        </div>
                                        <div className="input-radio">
                                            <input type="radio" id="private"  onChange={handleChange('privacy')} name="privacy" defaultChecked={this.state.checkPrivate && this.state.checkPrivate} value={this.state.private.id} />
                                            <label htmlFor="private" className="last-btn">Private</label>
                                        </div>
                                    </div> */}
                                    <Col xs={12} className="p-0 pb-4">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.ConnectionErorr}</Typography>
                                    </Col>
                                </Col>
                            </Row>
                        </Container>
                        <div className="pt-4 text-right text-responsive-center">
                            <Button type="submit" size="large" className="btn-orange-gradiant pr-5 pl-5" variant="contained" to="#" >Next</Button>
                        </div>
                    </form>
                </div>
            );
        }
    }
}
const CREATE_BIO = gql
    `mutation( $specialities_id :Int ! 
    $title : Title !  $brif : Text $tags :[Name!] ){
    bioCreate(Inputs:{
      specialities_id : $specialities_id 
      title : $title
      brif : $brif
      tags : $tags
    }){
      Status{
        code
        message
      }
      bio{
        id
        user{
              name
              email
            }
      }
     
    }
  }`
const EDIT_BIO = gql
    `
  mutation($bio_id : Int !  $specialities_id :Int ! 
      $title : Title    $brif : Text $tags :[Name!] ){
    bioEdit(Inputs:{
         bio : {
          id : $bio_id
        }
        specialities_id : $specialities_id 
        title : $title
        brif : $brif
        tags : $tags
    }){
      Status{
        code
      }
      bio{
        title
        brif
        speciality{id name_en}
        tags
        bioTags{
          name
        }
        questions{ 
        id
          title
          maximum_time
          video{
            url
          }
        }
      }
     
    }
  }`


export default compose(
    graphql(CREATE_BIO, {
        name: "create_bio"
    }),
    graphql(EDIT_BIO, {
        name: "edit_bio"
    })
)(withRouter(Overview));
